import { makeAutoObservable } from 'mobx';
import {auth, types, endpoints} from 'main/tools';
import {Employee} from 'main/stores/employees';
import {DomainStore} from 'shared/store';
import _ from 'lodash';
import {redirect} from 'shared/tools';

class OnboardBankingState {
  store = new DomainStore();

  employee;
  bankingChequeHelperOpen = false;
  errors = {};

  constructor() {
    makeAutoObservable(this, {
      store: false
    });
  }

  async load() {
    await this.store._compose([
      endpoints.EMPLOYEE_DETAILS.with(auth.employee.id)
    ]);

    this.employee = new Employee(
      this.store._getSingle(types.EMPLOYEE_DETAILS, {id: auth.employee.id})
    );
  }

  openBankingChequeHelperModal() {
    this.bankingChequeHelperOpen = true;
  }

  resetModals() {
    this.bankingChequeHelperOpen = false;
  }

  async nextStep() {
    const {model, errors} = await this.store.patch(
      endpoints.EMPLOYEE_ONBOARD.BANKING_INFO.with(auth.employee.id),
      types.EMPLOYEE_DETAILS,
      this.employee
    );
    this.errors = errors;

    if (model) {
      return redirect('/onboard');
    }
  }

  removeFile() {
    this.employee.bankAccount.cheque = null;
  }

  mergeFile(file) {
    this.employee.bankAccount.merge({cheque: file});
  }

  updateFile(files) {
    const file = _.head(files);
    file ? this.mergeFile(file) : this.removeFile();
  }

  get isTemporaryResident() {
    return _.startsWith(this.employee.sin, '9');
  }

  get sinExpiryDate() {
    return this.isTemporaryResident ? this.employee.sinExpiryDate : '';
  }
}

export default OnboardBankingState;
